"use client";
import { useCallback } from "react";
import { enqueueSnackbar, VariantType } from "notistack";

import { SNACKBAR_AUTO_HIDE_DURATION } from "ui/constants/styles";

export const useSnackbar = () => {
  const showSnackbar = useCallback(
    (
      type: VariantType,
      message: string,
      action?: React.ReactNode,
      autoHideDuration = SNACKBAR_AUTO_HIDE_DURATION
    ) => {
      enqueueSnackbar(message as string, {
        variant: type,
        action,
        autoHideDuration,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const showErrorSnackbar = useCallback(
    (message: string, action?: React.ReactNode, autoHideDuration?: number) => {
      return showSnackbar("error", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  const showSuccessSnackbar = useCallback(
    (message: string, action?: React.ReactNode, autoHideDuration?: number) => {
      return showSnackbar("success", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  const showInfoSnackbar = useCallback(
    (message: string, action?: React.ReactNode, autoHideDuration?: number) => {
      return showSnackbar("info", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  const showWarningSnackbar = useCallback(
    (message: string, action?: React.ReactNode, autoHideDuration?: number) => {
      return showSnackbar("warning", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  return {
    showInfoSnackbar,
    showErrorSnackbar,
    showSuccessSnackbar,
    showWarningSnackbar,
  };
};
